export default __webpack_public_path__ + "static/media/site_settings_en.1e885e74.png";